class LoyaltyLionRewardsColour {
  constructor() {
    this.buttonColour();
  }

  buttonColour() {
    let benefitsButton = document.querySelector('.lion-tier-box__title');
    if (benefitsButton) {
      let buttonText = benefitsButton.innerText;
      console.log(`Button text is: ${buttonText}`);

      if (buttonText === "Bronze") {
        benefitsButton.classList.add('bronze');
      } else if (buttonText === "Silver") {
        benefitsButton.classList.add('silver');
      } else if (buttonText === "Gold") {
        benefitsButton.classList.add('gold');
      } else if (buttonText === "Platinum") {
        benefitsButton.classList.add('platinum');
      } else {
        benefitsButton.classList.add('unset');
      }
    }
  }
}

export default LoyaltyLionRewardsColour;